export default class Globals { }
//Customer
Globals.RemoteCacheCustomerPrefix = 'CO::';
Globals.CacheAllCustomersTTL = 60 * 60; //a hour
Globals.CacheCustomerTTL = 60; //a minute
//Tenant
Globals.RemoteCacheTenantPrefix = 'TN::';
Globals.CacheAllTenantsTTL = 60*60; //a hour
Globals.CacheTenantTTL = 60; //a minute